import { CommonModule, Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
  ROUTE_DQF,
  ROUTE_DQF_ABSTRACT,
  ROUTE_DQF_BACKGROUND_CHECK_PROCESSING,
  ROUTE_DQF_DOCUMENT_UPLOAD,
  ROUTE_DQF_ONTARIO_CVOR_ABSTRACT,
  ROUTE_DQF_POLICE_CERTIFICATE,
  ROUTE_DQF_PRE_EMPLOYMENT_CERTIFICATE,
  ROUTE_DQF_REVIEW,
  ROUTE_DQF_SIGN_DECLARATION,
  ROUTE_DQF_UPLOADS,
  ROUTE_ON_DUTY_HOURS
} from 'src/app/shared/routes';
import { DqfDocument } from '../models/dqfDocument';
import { DriverQualificationService } from '../service/driver-qualification.service';

import { MatBottomSheet } from '@angular/material/bottom-sheet';
import dayjs from 'dayjs';
import { Subscription } from 'rxjs';
import { filter, finalize, pairwise } from 'rxjs/operators';
import { RegistrationService } from 'src/app/registration/shared/registration.service';
import { CARRIER_UPLOAD_REQUESTED } from 'src/app/shared/constants';
import { Notification } from 'src/app/shared/models/notification.model';
import { ToastService } from 'src/app/shared/toast/toast.service';
import {
  ALL_DRIVER_DOCS_ARRAY,
  DOCTYPE_ACCIDENT_HISTORY,
  DOCTYPE_DRIVING_EXPERIENCE,
  DOCTYPE_EMP_HISTORY,
  DOCTYPE_LICENSE_TYPE,
  DOCTYPE_ON_DUTY_HOURS,
  DOCTYPE_PERSONAL_INFO,
  DOCTYPE_RESIDENCE_HISTORY,
  DOCTYPE_TRAFFIC_CONVICTION,
  DQF_DOC_STATUS,
  DRIVER_DOC_CONTEXT_INITIAL_DQF,
  EMPLOYMENT_HISTORY_CHECK,
  OPTIONAL_DRIVER_DOCS,
  DQF_SUBMITTED_STATUSES
} from '../constants';
import { DqfSignaturePanelComponent } from '../dqf-signature-panel/dqf-signature-panel.component';
import { Action } from 'src/app/loads-shared/action';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/dialog/confitmation-dialog/confirmation-dialog.component';
import { CompleteProfileSheetComponent } from '../complete-profile-sheet/complete-profile-sheet.component';

const DQF_STATUS_PROCESSING = 'Processing';
const STATUS_REJECTED = 'Rejected';
const STATUS_PENDING = 'Pending';
const DOC_STATUS_DRIVER_REVIEWED = 'DriverReviewed';
const DOCUMENT_REQUESTED = 'CarrierUploadRequested';
const DRIVER_UPLOADS = 'Driver Uploads';
const DRIVER_UPLOADS_DISPLAY_NAME = 'Upload your documents';
const EXPIRED_LICENSE_WARNING = 'Enter valid license to move forward';
const DOCUMENT_TYPE_SIGN = 'declarationForm';
const DOCUMENT_SIGN_DISPLAY_NAME = 'Declaration';
const EMPLOYMENT_HISTORY_CHECK_DISPLAY_NAME = 'Employment History Check';
const ACTOR_TYPE_DRIVER = 'driver';
const PENDING_STATUS = 'Pending';
const SIGNED_STATUS = 'signed';
const UPLOADED_STATUS = 'uploaded';
const PATH_INCORPORATION = 'incorporation';

const UPDATE_DQF_DOC_MODEL = {
  attachedDocument: {
    type: '',
    status: DOC_STATUS_DRIVER_REVIEWED
  }
};
export interface DocumentAction {
  status: string;
  displayName?: string;
  iconName?: string;
  type: string;
  rejectionReason?: string;
  isRequirementsCompleted: boolean;
  clickHandler?: (status: string) => void;
  order?: number;
  uploaded?: number;
  total?: number;
  hasIcon?: boolean;
  id?: string;
  isRejected?: boolean;
  action?: string;
  licenseProvince?: string;
}
@Component({
  selector: 'app-dqf-document-upload',
  templateUrl: './dqf-document-upload.component.html',
  styleUrls: ['./dqf-document-upload.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatBottomSheetModule]
})
export class DqfDocumentUploadComponent implements OnInit, OnDestroy {
  dqfId: string;
  dqfData: DqfDocument;
  clubbedDocuments: DocumentAction[] = [];
  personalInfoStatus: string;
  drugAlocoholStatus: string;
  trainingCertiStatus: string;
  drivingAbstract: string;
  empHistoryStatus: string;
  drivingExperienceStatus: string;
  drivingLicenseStatus: string;
  residenceHistoryStatus: string;
  accidentHistoryStatus: string;
  enableSubmit: boolean = true;
  trafficHistoryStatus: string;
  onDutyStatus: string;
  abstractStatus: string;

  isPersonalInfoStatus: boolean = false;
  isDrugAlcoholPresent: boolean = false;
  isTrainingCerti: boolean = false;
  isDrivingAbstract: boolean = false;
  isDrivingExperience: boolean = false;
  isEmpHistory: boolean = false;
  isAllowToSign: boolean = false;
  isReview = false;
  dqfAttachments = [];
  driverUploadDocuments = ALL_DRIVER_DOCS_ARRAY;
  driverUploadDocs: DocumentAction[] = [];
  isDriverUploadsExpanded = true;
  readonly driverUploadsDisplayName = DRIVER_UPLOADS_DISPLAY_NAME;
  licenseProvince = null;
  backImageUploadedDate: any;
  frontImageUploadedDate: any;
  savedPaymentOrders: any;
  loading: boolean;
  driver: any;
  driverDocuments: any;
  private routerNavigationSub: Subscription;
  private driverType: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly location: Location,
    private readonly router: Router,
    private readonly registrationService: RegistrationService,
    private readonly driverQualificationService: DriverQualificationService,
    private readonly toastService: ToastService,
    private readonly bottomSheet: MatBottomSheet,
    @Inject('environmentData') private environment: any,
    private readonly dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.dqfId = this.dqfId ? this.dqfId : this.route.snapshot.paramMap.get('id');
    this.driver = this.registrationService.getDriver();
    this.driverDocuments = this.driver?.notification;
    this.getStripeOrders();
    this.driverQualificationService.dqfId = this.dqfId;
    //this.getLicense();
    this.findUnSignedDocumentsAndGetHelloSignUrls();
    this.subscribeToRefreshDqfWhenReturningFromOnDuty();
  }

  /** Reload DQF when navigating back from on-duty hours so section status/checkmark updates. */
  private subscribeToRefreshDqfWhenReturningFromOnDuty(): void {
    this.routerNavigationSub = this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        pairwise()
      )
      .subscribe(([prev, curr]) => {
        if (!this.dqfId) {
          return;
        }
        const documentsUrlSegment = `${ROUTE_DQF_DOCUMENT_UPLOAD}/${this.dqfId}`;
        const cameFromDocumentForm =
          prev.urlAfterRedirects.includes(`/${ROUTE_ON_DUTY_HOURS}`) ||
          prev.urlAfterRedirects.includes(`/${ROUTE_DQF_POLICE_CERTIFICATE}`) ||
          prev.urlAfterRedirects.includes(`/${ROUTE_DQF_PRE_EMPLOYMENT_CERTIFICATE}`) ||
          prev.urlAfterRedirects.includes(`/${ROUTE_DQF_ABSTRACT}`);
        const nowOnDocuments =
          curr.urlAfterRedirects.includes(documentsUrlSegment) &&
          curr.urlAfterRedirects.includes(`/${ROUTE_DQF}/`);
        if (cameFromDocumentForm && nowOnDocuments) {
          this.getDQF();
        }
      });
  }

  getStripeOrders(): void {
    this.loading = true;
    this.driverQualificationService
      .getStripeOrders(this.driver.id)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((response: any) => {
        if (response) {
          this.savedPaymentOrders = response;
          localStorage.setItem('stripePaymentOrders', JSON.stringify(response));
        }
        this.getLicense();
      });
  }

  ngOnDestroy(): void {
    localStorage.removeItem('stripePaymentOrders');
    this.routerNavigationSub?.unsubscribe();
  }

  /** Driver finished on-duty entry while DQF attachment is still Pending/Processing. */
  private isOnDutyHoursDriverSectionComplete(doc: any): boolean {
    return (
      doc?.type === DOCTYPE_ON_DUTY_HOURS &&
      doc?.isRequirementsCompleted === true &&
      (doc?.status === STATUS_PENDING || doc?.status === DQF_STATUS_PROCESSING)
    );
  }

  getDocumentIcon(doc: any): string {
    const iconMap: { [key: string]: string } = {
      'PersonalInfo': 'profile-info-icon',
      'LicenseInfo': 'license-info-icon',
      'ResidenceHistory': 'residence-icon',
      'DrivingExperience': 'driving-exp-icon',
      'EmploymentHistory': 'emp-history-icon',
      'AccidentRecords': 'accident-record-icon',
      'TrafficConvictions': 'accident-record-icon',
      'OnDutyHours': 'on-duty-icon',
      'DriverUploads': 'folder-icon',
      'DriverLicense': 'license-info-icon',
      'Abstract': 'accident-record-icon',
      'PoliceClearance': 'car-icon',
      'PreEmploymentScreening': 'zoom-icon',
      // ball-pen.svg has no fill, so it renders invisible — use document like dqf-upload
      'declarationForm': 'document',
      'Declaration': 'document',
      'EmploymentHistoryCheck': 'document',
      'ClearingHouseReport': 'folder-icon'
    };

    return iconMap[doc.type] || iconMap[doc.displayName?.replace(/\s+/g, '')] || 'folder-icon';
  }

  getStatusIcon(doc: any): string {
    // Special handling for Driver Uploads section
    if (doc.displayName === DRIVER_UPLOADS) {
      const uploadedCount = doc.uploaded || 0;
      const totalCount = doc.total || this.getTotalDriverDocumentsCount();

      if (doc.isRejected) {
        return 'error';
      } else if (uploadedCount === totalCount && totalCount > 0) {
        return 'check_circle';
      } else if (uploadedCount > 0 && uploadedCount < totalCount) {
        return 'upload';
      } else {
        return 'radio_button_unchecked';
      }
    }

    if (doc.type === DOCTYPE_LICENSE_TYPE && !this.areLicenseImagesValid()) {
      return 'error_outline';
    }

    if (this.isOnDutyHoursDriverSectionComplete(doc)) {
      return 'check_circle';
    }

    if (this.isCarrierUploadRequestedDoc(doc)) {
      return 'schedule';
    }

    // Use same logic as original dqf-item-box component
    const isRejected = doc.status === 'Rejected' || doc.isRejected;
    const isProcessing = doc.status === 'Processing';
    const isCompleted = doc.status === 'DriverReviewed' || doc.status === 'DriverSigned' || doc.status === 'Accepted' ||
      (doc.uploaded && doc.total && +doc.uploaded === +doc.total);
    const isPending = doc.status === 'Pending';
    const hasPartialUpload = doc.uploaded && doc.total && +doc.uploaded > 0 && +doc.uploaded < +doc.total;

    if (isRejected) {
      return 'error';
    } else if (isProcessing) {
      return 'sync';
    } else if (isCompleted) {
      return 'check_circle';
    } else if (isPending) {
      if (this.isOptionalDriverDocumentSkipped(doc)) {
        return 'info';
      }
      // Show error_outline icon if requirements are not completed for pending status
      if (doc.isRequirementsCompleted === false) {
        return 'error_outline';
      }
      return 'schedule';
    } else if (hasPartialUpload) {
      return 'upload';
    } else {
      return 'radio_button_unchecked';
    }
  }

  getCardStatusClass(doc: any): string {
    // Special handling for Driver Uploads section
    if (doc.displayName === DRIVER_UPLOADS) {
      const uploadedCount = doc.uploaded || 0;
      const totalCount = doc.total || this.getTotalDriverDocumentsCount();

      if (doc.isRejected) {
        return 'status-error';
      } else if (uploadedCount === totalCount && totalCount > 0) {
        return 'status-completed';
      } else if (uploadedCount > 0 && uploadedCount < totalCount) {
        return 'status-warning';
      } else {
        return 'status-incomplete';
      }
    }

    if (doc.type === DOCTYPE_LICENSE_TYPE && !this.areLicenseImagesValid()) {
      return 'status-pending';
    }

    if (this.isOnDutyHoursDriverSectionComplete(doc)) {
      return 'status-completed';
    }

    if (this.isCarrierUploadRequestedDoc(doc)) {
      return 'status-requested';
    }

    const isRejected = doc.status === 'Rejected' || doc.isRejected;
    const isProcessing = doc.status === 'Processing';
    const isCompleted = doc.status === 'DriverReviewed' || doc.status === 'DriverSigned' || doc.status === 'Accepted' ||
      (doc.uploaded && doc.total && +doc.uploaded === +doc.total);
    const isPending = doc.status === 'Pending';
    const hasPartialUpload = doc.uploaded && doc.total && +doc.uploaded > 0 && +doc.uploaded < +doc.total;

    let statusClass;
    if (isRejected) {
      statusClass = 'status-error';
    } else if (isProcessing) {
      statusClass = 'status-processing';
    } else if (isCompleted) {
      statusClass = 'status-completed';
    } else if (isPending) {
      if (this.isOptionalDriverDocumentSkipped(doc)) {
        statusClass = 'status-optional';
      } else if (doc.isRequirementsCompleted === false) {
        // Show warning styling if requirements are not completed for pending status
        statusClass = 'status-warning action-required';
      } else {
        statusClass = 'status-pending';
      }
    } else if (hasPartialUpload) {
      statusClass = 'status-warning';
    } else {
      statusClass = 'status-incomplete';
    }

    return statusClass;
  }

  getStatusText(doc: any): string {
    // For Driver Uploads section, show document count instead of "Not Started"
    if (doc.displayName === DRIVER_UPLOADS) {
      const uploadedCount = doc.uploaded || 0;
      const totalCount = doc.total || this.getTotalDriverDocumentsCount();
      return `${uploadedCount}/${totalCount} documents uploaded`;
    }

    // License information: if either image missing/corrupted, ask user to upload again
    if (doc.type === DOCTYPE_LICENSE_TYPE && !this.areLicenseImagesValid()) {
      return 'Upload image again';
    }

    if (this.isOnDutyHoursDriverSectionComplete(doc)) {
      return 'Completed';
    }

    if (this.isCarrierUploadRequestedDoc(doc)) {
      return 'Requested Carrier';
    }

    const isRejected = doc.status === 'Rejected' || doc.isRejected;
    const isProcessing = doc.status === 'Processing';
    const isCompleted = doc.status === 'DriverReviewed' || doc.status === 'DriverSigned' || doc.status === 'Accepted' ||
      (doc.uploaded && doc.total && +doc.uploaded === +doc.total);
    const isPending = doc.status === 'Pending';
    const hasPartialUpload = doc.uploaded && doc.total && +doc.uploaded > 0 && +doc.uploaded < +doc.total;

    if (isRejected) {
      return 'Rejected';
    } else if (isProcessing) {
      return 'Processing';
    } else if (isCompleted) {
      return 'Completed';
    } else if (isPending) {
      if (this.isOptionalDriverDocumentSkipped(doc)) {
        return 'Optional';
      }
      // Details already on file — driver should open, review, and confirm
      if (doc.isRequirementsCompleted === true) {
        return 'Review and confirm';
      }
      // Missing required info — driver needs to fill in this section
      return 'Complete this section';
    } else if (hasPartialUpload) {
      return `In Progress (${doc.uploaded}/${doc.total})`;
    } else {
      return 'Tap to get started';
    }
  }

  private isCarrierUploadRequestedDoc(doc: { status?: string }): boolean {
    return doc?.status === DOCUMENT_REQUESTED || doc?.status === CARRIER_UPLOAD_REQUESTED;
  }

  private getTotalDriverDocumentsCount(): number {
    if (!this.dqfData?.attachedDocuments) {
      return ALL_DRIVER_DOCS_ARRAY.length;
    }

    return this.dqfData.attachedDocuments.filter(doc => ALL_DRIVER_DOCS_ARRAY.includes(doc.type)).length;
  }

  getDQF(): void {
    this.driverQualificationService.getDqfById(this.dqfId).subscribe(res => {
      if (res) {
        this.dqfData = res;
        this.driverQualificationService.dqfData = res;
        if (this.dqfData?.attachedDocuments?.length > 0) {
          this.dqfAttachments = [...this.dqfData.attachedDocuments];
          const attachments = this.clubAttachDocuments(this.dqfAttachments);
          this.addDriverFolder(attachments);
          this.loadDriverUploadDocuments();
          this.clubbedDocuments = attachments;
          
          if (this.dqfData.status == DQF_STATUS_PROCESSING) {
            this.isReview = this.checkIsDqfIsReadyToReview();
          }
          if (this.dqfData.status == STATUS_REJECTED) {
            let documentCount = 0;
            this.dqfData.attachedDocuments.forEach(doc => {
              if (this.isOptionalDriverDocumentReadyForSubmit(doc)) {
                documentCount++;
              } else if (!(doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING)) {
                documentCount++;
              }
            });
            if (documentCount == this.dqfData.attachedDocuments.length) {
              this.isReview = true;
            }
          }
        }
      }
    });
  }

  findUnSignedDocumentsAndGetHelloSignUrls() {
    const declarationModel = {
      actorType: ACTOR_TYPE_DRIVER,
      documentDisplayName: '',
      documentType: '',
      context: DRIVER_DOC_CONTEXT_INITIAL_DQF,
      dqfId: this.dqfId,
      // Uncomment this when we want to use canvas signature
      canvasSignature: false
    };

    let notifications = this.registrationService.getDriver().notification;
    if (notifications.length) {
      if (!this.environment.featureFlags?.enableZohoSign) {
        declarationModel.documentType = DOCUMENT_TYPE_SIGN;
        declarationModel.documentDisplayName = DOCUMENT_SIGN_DISPLAY_NAME;
        // Uncomment this when we want to use canvas signature
        delete declarationModel.canvasSignature;
        this.checkDocumentSigningRequired(notifications, declarationModel);
      }
      declarationModel.documentType = EMPLOYMENT_HISTORY_CHECK;
      declarationModel.documentDisplayName = EMPLOYMENT_HISTORY_CHECK_DISPLAY_NAME;
      // Uncomment this when we want to use canvas signature
      declarationModel.canvasSignature = true;
      this.checkDocumentSigningRequired(notifications, declarationModel);
    } else {
      if (!this.environment.featureFlags?.enableZohoSign) {
        declarationModel.documentType = DOCUMENT_TYPE_SIGN;
        declarationModel.documentDisplayName = DOCUMENT_SIGN_DISPLAY_NAME;
        // Uncomment this when we want to use canvas signature
        delete declarationModel.canvasSignature;
        this.getHelloSignUrls(declarationModel);
      }
      declarationModel.documentType = EMPLOYMENT_HISTORY_CHECK;
      declarationModel.documentDisplayName = EMPLOYMENT_HISTORY_CHECK_DISPLAY_NAME;
      // Uncomment this when we want to use canvas signature
      declarationModel.canvasSignature = true;
      this.getHelloSignUrls(declarationModel);
    }
  }

  private checkDocumentSigningRequired(notifications: Notification[], document: any): void {
    const filteredNotifications = notifications.filter(
      notification =>
        notification.type === document.documentType && notification?.dqfId === this.driverQualificationService.dqfId
    );
    if (filteredNotifications.length) {
      const hasUploadedStatus = filteredNotifications.some(
        notification => notification.status === UPLOADED_STATUS || notification.status === SIGNED_STATUS
      );
      if (!hasUploadedStatus) {
        this.getHelloSignUrls(document);
      }
    } else {
      this.getHelloSignUrls(document);
    }
  }

  private getHelloSignUrls(document: any): void {
    this.driverQualificationService.getHelloSignUrl(document).subscribe();
  }

  checkIsDqfIsReadyToReview(): boolean {
    let isPresent = 0;
    this.dqfData.attachedDocuments.forEach(doc => {
      if (this.isOptionalDriverDocumentReadyForSubmit(doc)) {
        isPresent++;
        return;
      }
      if (
        doc.isRequirementsCompleted &&
        (doc.status === DOC_STATUS_DRIVER_REVIEWED || doc.status === DQF_DOC_STATUS.DRIVER_SIGNED)
      ) {
        if (doc.type === DOCTYPE_LICENSE_TYPE && !this.areLicenseImagesValid()) {
          // License section not ready: front or back image missing/corrupted
        } else {
          isPresent++;
        }
      }
      if (doc.status === DOCUMENT_REQUESTED) {
        // CarrierUploadRequested means the driver has completed their part (same for PCC and other docs)
        isPresent++;
      }
    });

    return isPresent === this.dqfData.attachedDocuments?.length;
  }

  private isOptionalDriverDocumentReadyForSubmit(doc: { type?: string; status?: string }): boolean {
    return this.isOptionalDriverDocument(doc?.type) && doc?.status !== STATUS_REJECTED;
  }

  private isOptionalDriverDocumentSkipped(doc: { type?: string; status?: string; isRequirementsCompleted?: boolean }): boolean {
    if (DQF_SUBMITTED_STATUSES.includes(this.dqfData?.status)) {
      return false;
    }

    return (
      this.isOptionalDriverDocument(doc?.type) &&
      doc?.status === STATUS_PENDING &&
      doc?.isRequirementsCompleted !== true
    );
  }

  private isOptionalDriverDocument(type?: string): boolean {
    return !!type && (OPTIONAL_DRIVER_DOCS as readonly string[]).includes(type);
  }

  goToProfileInfo(doc?: any): void {
    if (doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING) {
      if (doc.isRequirementsCompleted) {
        UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
        this.driverQualificationService.updateDQFStatusToReview(doc, UPDATE_DQF_DOC_MODEL, () =>
          this.registrationService.navigateToPersonalInformation(this.route)
        );
      } else {
        this.registrationService.navigateToPersonalInformation(this.route);
      }
    } else {
      this.registrationService.navigateToPersonalInformation(this.route);
    }
  }
  goToLicenseInfo(doc?: any): void {
    if (doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING) {
      if (doc.isRequirementsCompleted) {
        UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
        this.driverQualificationService.updateDQFStatusToReview(doc, UPDATE_DQF_DOC_MODEL, () =>
          this.registrationService.onNavigateToLicense(this.route)
        );
      } else {
        this.registrationService.onNavigateToLicense(this.route);
      }
    } else {
      this.registrationService.onNavigateToLicense(this.route);
    }
  }
  goToResidenceHistory(doc?: any): void {
    if (doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING) {
      if (doc.isRequirementsCompleted) {
        UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
        this.driverQualificationService.updateDQFStatusToReview(doc, UPDATE_DQF_DOC_MODEL, () =>
          this.registrationService.navigateToResidenceHistory(this.route)
        );
      } else {
        this.registrationService.navigateToResidenceHistory(this.route);
      }
    } else {
      this.registrationService.navigateToResidenceHistory(this.route);
    }
  }
  goToDrivingExperience(doc?: any): void {
    if (doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING) {
      if (doc.isRequirementsCompleted) {
        UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
        this.driverQualificationService.updateDQFStatusToReview(doc, UPDATE_DQF_DOC_MODEL, () =>
          this.registrationService.navigateToDrivingExperience(this.route)
        );
      } else {
        this.registrationService.navigateToDrivingExperience(this.route);
      }
    } else {
      this.registrationService.navigateToDrivingExperience(this.route);
    }
  }
  goToEmpHistory(doc?: any): void {
    if (doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING) {
      if (doc.isRequirementsCompleted) {
        UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
        this.driverQualificationService.updateDQFStatusToReview(doc, UPDATE_DQF_DOC_MODEL, () =>
          this.registrationService.navigateToEmploymentHistory(this.route)
        );
      } else {
        this.registrationService.navigateToEmploymentHistory(this.route);
      }
    } else {
      this.registrationService.navigateToEmploymentHistory(this.route);
    }
  }
  goToAccidentRecords(doc?: any): void {
    if (doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING) {
      if (doc.isRequirementsCompleted) {
        UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
        this.driverQualificationService.updateDQFStatusToReview(doc, UPDATE_DQF_DOC_MODEL, () =>
          this.registrationService.navigateToAccidentRecords(this.route)
        );
      } else {
        this.registrationService.navigateToAccidentRecords(this.route);
      }
    } else {
      this.registrationService.navigateToAccidentRecords(this.route);
    }
  }
  goToTrafficConviction(doc?: any): void {
    if (doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING) {
      if (doc.isRequirementsCompleted) {
        UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
        this.driverQualificationService.updateDQFStatusToReview(doc, UPDATE_DQF_DOC_MODEL, () =>
          this.registrationService.onNavigateToTrafficConvictions(this.route)
        );
      } else {
        this.registrationService.onNavigateToTrafficConvictions(this.route);
      }
    } else {
      this.registrationService.onNavigateToTrafficConvictions(this.route);
    }
  }

  goToOnHourDuty(doc?: any): void {
    if (doc.status == STATUS_REJECTED || doc.status == STATUS_PENDING) {
      if (doc.isRequirementsCompleted) {
        UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
        this.driverQualificationService.updateDQFStatusToReview(doc, UPDATE_DQF_DOC_MODEL, () =>
          this.navigateToOnDutyHours()
        );
      } else {
        this.navigateToOnDutyHours();
      }
    } else {
      this.navigateToOnDutyHours();
    }
  }

  backAction() {
    this.router.navigate([ROUTE_DQF]);
  }

  onReview(): void {
    if (this.isLicenseValid()) {
      this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_REVIEW}/${this.dqfId}`]);
    } else {
      this.toastService.showWarning(EXPIRED_LICENSE_WARNING);
    }
  }
  openSignature(): void {
    const bottomSheetRef = this.bottomSheet.open(DqfSignaturePanelComponent, {
      panelClass: 'signature-panel',
      data: {
        dqfId: this.dqfId
      }
    });
  }
  isLicenseValid(): boolean {
    const licenseInfo = this.registrationService.getLicenseStore();

    return dayjs(licenseInfo.expiryDate).isAfter(dayjs(), 'day');
  }

  openWarningDialog(): void {
    const actions = this.createAcceptDialogActions();
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Submit DQF?',
        message: 'Please complete all the DQF sections before this action',
        actions
      },
      disableClose: true
    });
    const confirmAction = actions[0];
    confirmAction.action = async () => this.dialogCancelAction(dialogRef, confirmAction);

    dialogRef.afterClosed().subscribe();
  }
  
  private dialogCancelAction(dialogRef: MatDialogRef<any>, confirmAction: Action): any {
    confirmAction.disabled = true;

    dialogRef.close();
  }

  isDriverUploadsSection(doc: DocumentAction): boolean {
    return doc?.displayName === DRIVER_UPLOADS;
  }

  toggleDriverUploads(event?: Event): void {
    event?.stopPropagation();
    this.isDriverUploadsExpanded = !this.isDriverUploadsExpanded;
  }

  onDriverUploadDocClick(event: Event, doc: DocumentAction): void {
    event.stopPropagation();
    if (doc?.clickHandler) {
      doc.clickHandler(doc as any);
    }
  }

  private loadDriverUploadDocuments(): void {
    if (!this.dqfData?.attachedDocuments) {
      this.driverUploadDocs = [];
      return;
    }

    const companyDriver = this.driver?.companyAssociations?.find((d: { id: string; driverType?: string }) =>
      d.id.includes(this.dqfData?.carrierCompanyId)
    );
    this.driverType = companyDriver
      ? companyDriver.driverType
      : this.driver?.companyDriverType || undefined;

    this.driverUploadDocs = this.driverQualificationService
      .bindDriverAttachments(
        this.dqfData.attachedDocuments,
        this.licenseProvince || '',
        this.driverType,
        this.navigateToDriverUploadDocument.bind(this),
        this.navigateToSignDeclaration.bind(this),
        this.navigateToAbstractDoc.bind(this),
        this.navigateToPoliceCertificateBasedOnAction.bind(this),
        this.navigateToPreEmploymentScreeningReport.bind(this),
        this.navigateToEmploymentHistoryCheck.bind(this),
        this.navigateToOntarioCvorAbstractDoc.bind(this)
      )
      .sort((a, b) => (a.order || 0) - (b.order || 0));
  }

  private navigateToDriverUploadDocument(doc: DocumentAction, callback: Function): void {
    if (doc.status == STATUS_REJECTED) {
      const sheetData = {
        displayName: doc.displayName,
        reason: doc.rejectionReason,
        type: doc.type
      };

      UPDATE_DQF_DOC_MODEL.attachedDocument.type = doc.type;
      this.driverQualificationService.openBottomSheetWithFunction(sheetData, UPDATE_DQF_DOC_MODEL, () =>
        callback()
      );
    } else {
      callback();
    }
  }

  private navigateToOntarioCvorAbstractDoc(): void {
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_ONTARIO_CVOR_ABSTRACT}`]);
  }

  private navigateToAbstractDoc(): void {
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_ABSTRACT}`]);
  }

  private navigateToPoliceClearanceCertificate(): void {
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_POLICE_CERTIFICATE}`]);
  }

  private navigateToBackgroundProcessingRequest(documentType: string, initiateStripe?: boolean): void {
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_BACKGROUND_CHECK_PROCESSING}`], {
      queryParams: { documentType: documentType, stripe: initiateStripe }
    });
  }

  private navigateToPreEmploymentScreeningReport(): void {
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_PRE_EMPLOYMENT_CERTIFICATE}`]);
  }

  private navigateToSignDeclaration(): void {
    const workPlaceSafety = this.registrationService.getWorkplaceSafetyStore();
    const isDriverOwnerOperator = this.driverType?.toLowerCase().includes('owneroperator') || false;
    const isWorkPlaceSafetyExists = !!workPlaceSafety && Object.keys(workPlaceSafety).length > 0;
    if (isDriverOwnerOperator && !isWorkPlaceSafetyExists) {
      const dialogRef = this.bottomSheet.open(CompleteProfileSheetComponent, {
        panelClass: 'signature-panel',
        disableClose: true,
        data: { completeIncorporation: true }
      });
      dialogRef.afterDismissed().subscribe(() => {
        this.router.navigate([`${PATH_INCORPORATION}`]);
      });
      return;
    }
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_SIGN_DECLARATION}`]);
  }

  private navigateToEmploymentHistoryCheck(): void {
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_DQF_SIGN_DECLARATION}`], {
      queryParams: { type: EMPLOYMENT_HISTORY_CHECK }
    });
  }

  private navigateToPoliceCertificateBasedOnAction(info: any): void {
    const hasUploadedDocument = this.driverDocuments?.some(
      doc => doc.dqfId === this.dqfId && doc.type === 'PoliceClearance' && doc.status === 'uploaded'
    );
    const requiresReupload =
      info.status === STATUS_PENDING ||
      info.status === STATUS_REJECTED ||
      info.isRequirementsCompleted === false;

    this.navigateToDriverUploadDocument(info, () => {
      if (info['action'] === 'collect') {
        const doesDriverHavePccOrder = this.driverDocuments?.find(
          doc => doc.dqfId === this.dqfId && doc.type === 'PoliceClearance'
        );
        if (doesDriverHavePccOrder) {
          this.navigateToBackgroundProcessingRequest('Criminal Record (Background) Check');
        } else {
          this.navigateToBackgroundProcessingRequest('Criminal Record (Background) Check', true);
        }
      } else if (hasUploadedDocument && !requiresReupload) {
        this.navigateToPoliceClearanceCertificate();
      } else if (requiresReupload || !hasUploadedDocument) {
        this.navigateToPoliceClearanceCertificate();
      } else {
        this.navigateToBackgroundProcessingRequest('Criminal Record (Background) Check');
      }
    });
  }

  private addDriverFolder(attachedDocument: DocumentAction[]) {
    const hasDriverUpload = this.dqfData?.attachedDocuments?.some(doc => this.driverUploadDocuments.includes(doc.type));
    if (hasDriverUpload) {
      this.addToAttachment(DRIVER_UPLOADS, this.goToUploadRecords.bind(this), attachedDocument);
    }
  }

  private addToAttachment(displayName: string, onClickEvent: any, attachedDocument: DocumentAction[]): void {
    let uploadedCount = 0;
    let rejectedCount = 0;

    if (displayName === DRIVER_UPLOADS) {

      if (this.environment?.featureFlags?.enableStripe) {
        uploadedCount = this.dqfData?.attachedDocuments?.filter(e => {
          const isPoliceClearance = e.type?.toLowerCase() === 'policeclearance' && e.status !== 'Pending';
          const doesDriverHavePccOrderd = this.driverDocuments.find(
            doc => doc.dqfId === this.dqfId && doc.type === 'PoliceClearance'
          );
          const isAcceptedPoliceClearance =
            isPoliceClearance && (e.isRequirementsCompleted || e.status?.toLowerCase() === 'accepted');
          const isCarrierUploadRequested = e.status === CARRIER_UPLOAD_REQUESTED;

          const isCompletedOrRequested =
            (!isPoliceClearance && (e.isRequirementsCompleted || isCarrierUploadRequested)) ||
            (isPoliceClearance &&
              (doesDriverHavePccOrderd || isAcceptedPoliceClearance || isCarrierUploadRequested));

          const isExpectedType = this.driverUploadDocuments.some(type => type.toLowerCase() === e.type.toLowerCase());

          if (isCompletedOrRequested && isExpectedType) {
            return true;
          }
          return false;
        })?.length;

        rejectedCount = this.dqfData?.attachedDocuments?.filter(
          e =>
            e.isRequirementsCompleted &&
            e.status === STATUS_REJECTED &&
            this.driverUploadDocuments.some(type => type.toLowerCase() === e.type.toLowerCase())
        )?.length;
      } else {
        uploadedCount = this.dqfData?.attachedDocuments?.filter(
          e =>
            (
              e.status === CARRIER_UPLOAD_REQUESTED ||
              (e.isRequirementsCompleted && (e.status === 'DriverReviewed' || e.status === 'DriverSigned' || e.status === 'Accepted'))
            ) &&
            this.driverUploadDocuments.some(type => type.toLowerCase() === e.type.toLowerCase())
        )?.length;

        rejectedCount = this.dqfData?.attachedDocuments?.filter(
          e =>
            e.isRequirementsCompleted &&
            e.status === STATUS_REJECTED &&
            this.driverUploadDocuments.some(type => type.toLowerCase() === e.type.toLowerCase())
        )?.length;
      }
    }

    const upload: DocumentAction = {
      status: null,
      type: '',
      rejectionReason: '',
      isRequirementsCompleted: null,
      iconName: 'folder-icon',
      displayName: displayName,
      uploaded: uploadedCount || 0,
      hasIcon: false,
      isRejected: rejectedCount ? true : false,
      licenseProvince: this.licenseProvince,
      clickHandler: () => {
        onClickEvent(upload);
      }
    };
    attachedDocument.push(upload);
  }

  private goToUploadRecords(documentData: DocumentAction): void {
    this.router.navigateByUrl(`${ROUTE_DQF}/${ROUTE_DQF_UPLOADS}?type=` + documentData.displayName);
  }

  private clubAttachDocuments(attachedDocuments): DocumentAction[] {
    let documents: DocumentAction[] = [];
    attachedDocuments.forEach(doc => {
      let info: DocumentAction = {
        status: doc.status,
        type: doc.type,
        rejectionReason: doc.rejectionReason,
        isRequirementsCompleted: doc.isRequirementsCompleted,
        licenseProvince: this.licenseProvince
      };

      if (info.type == DOCTYPE_PERSONAL_INFO) {
        info.iconName = 'profile-info-icon';
        info.displayName = 'Personal Information';
        info.clickHandler = () => {
          this.goToProfileInfo(info);
        };
        info.order = 1;
        documents.push(info);
        return;
      }
      if (info.type == DOCTYPE_LICENSE_TYPE) {
        info.iconName = 'license-info-icon';
        info.displayName = 'License information';
        info.clickHandler = () => {
          this.goToLicenseInfo(info);
        };
        info.order = 2;
        documents.push(info);
        return;
      }
      if (info.type == DOCTYPE_RESIDENCE_HISTORY) {
        info.iconName = 'residence-icon';
        info.displayName = 'Residence History';
        info.clickHandler = () => {
          this.goToResidenceHistory(info);
        };
        info.order = 3;
        documents.push(info);
        return;
      }
      if (info.type == DOCTYPE_DRIVING_EXPERIENCE) {
        info.iconName = 'driving-exp-icon';
        info.displayName = 'Driving Experience';
        info.clickHandler = () => {
          this.goToDrivingExperience(info);
        };
        info.order = 4;
        documents.push(info);
        return;
      }
      if (info.type == DOCTYPE_EMP_HISTORY) {
        info.iconName = 'emp-history-icon';
        info.displayName = 'Employment History';
        info.clickHandler = () => {
          this.goToEmpHistory(info);
        };
        info.order = 5;
        documents.push(info);
        return;
      }
      if (info.type == DOCTYPE_ACCIDENT_HISTORY) {
        info.iconName = 'accident-record-icon';
        info.displayName = 'Accident Records';
        info.clickHandler = () => {
          this.goToAccidentRecords(info);
        };
        info.order = 6;
        documents.push(info);
        return;
      }
      if (info.type == DOCTYPE_TRAFFIC_CONVICTION) {
        info.iconName = 'accident-record-icon';
        info.displayName = 'Traffic Convictions';
        info.clickHandler = () => {
          this.goToTrafficConviction(info);
        };
        info.order = 7;
        documents.push(info);
        return;
      }
      if (info.type == DOCTYPE_ON_DUTY_HOURS) {
        info.iconName = 'on-duty-icon';
        info.displayName = 'On-Duty hours';
        info.clickHandler = () => {
          this.goToOnHourDuty(info);
        };
        info.order = 8;
        documents.push(info);
        return;
      }
    });
    return documents.sort((first, second) => first.order - second.order);
  }

  private navigateToOnDutyHours(): void {
    this.router.navigate([`${ROUTE_DQF}/${ROUTE_ON_DUTY_HOURS}`]);
  }

  private getLicense(): void {
    this.registrationService.getLicense(true).subscribe(license => {
      if (license) {
        this.licenseProvince = license.issuingProvince?.toLowerCase();
        this.frontImageUploadedDate = (license as any).frontImageUploadedDate;
        this.backImageUploadedDate = (license as any).backImageUploadedDate;

        // Update the store with the fresh data to ensure consistency
        this.registrationService.updateLicenseStore(license);
      }
      this.getDQF();
    });
  }

  private areLicenseImagesValid(): boolean {
    const frontValid = !!(this.frontImageUploadedDate && this.frontImageUploadedDate !== '');
    const backValid = !!(this.backImageUploadedDate && this.backImageUploadedDate !== '');
    return frontValid && backValid;
  }

  private createAcceptDialogActions(): Action[] {
    const actions: Action[] = [];

    const OkayAction = {
      name: 'OK',
      action: (data: any) => { },
      disabled: false,
      color: 'primary'
    } as Action;
    actions.push(OkayAction);

    return actions;
  }
}
